<template>
  <span class="a-pill" :class="[`a-pill--${kind}`, { 'a-pill--dot': dot }]">
    <span v-if="dot" class="a-pill__dot" />
    <i v-if="icon" class="material-icons-round a-pill__icon">{{ icon }}</i>
    <slot />
  </span>
</template>

<script>
export default {
  name: 'APill',
  props: {
    kind: {
      type: String,
      default: 'default',
      validator: (v) => ['default', 'ok', 'warn', 'err', 'info', 'yellow', 'dark'].includes(v),
    },
    icon: { type: String, default: '' },
    dot:  { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/pineapple';

.a-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 22px;
  padding: 0 9px;
  border-radius: 999px;
  font-family: $p-font-body;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.01em;
  border: 1px solid transparent;
  white-space: nowrap;

  .a-pill__icon { font-size: 12px !important; }
  .a-pill__dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
  }
}

.a-pill--default { background: $p-panel-alt; color: $p-ink2;   border-color: $p-line; }
.a-pill--ok      { background: $p-ok-soft;   color: $p-ok;     border-color: rgba(30,140,102,0.25); }
.a-pill--warn    { background: $p-warn-soft; color: $p-warn;   border-color: rgba(201,138,10,0.25); }
.a-pill--err     { background: $p-err-soft;  color: $p-err;    border-color: rgba(196,74,58,0.25); }
.a-pill--info    { background: $p-info-soft; color: $p-info;   border-color: rgba(59,123,196,0.25); }
.a-pill--yellow  { background: $p-point-soft;color: $p-point-deep; border-color: $p-point; }
.a-pill--dark    { background: $p-ink;       color: $p-point;  border-color: $p-ink; }
</style>
